export const FETCH_PRICE_AUDIT_REQUEST = "FETCH_PRICE_AUDIT_REQUEST";
export const FETCH_PRICE_AUDIT_SUCCESS = "FETCH_PRICE_AUDIT_SUCCESS";
export const FETCH_PRICE_AUDIT_FAILURE = "FETCH_PRICE_AUDIT_FAILURE";

export const fetchPriceAuditRequest = (page = 1, page_size = 20) => ({
  type: FETCH_PRICE_AUDIT_REQUEST,
  payload: { page, page_size },
});

export const fetchPriceAuditSuccess = (data) => {
  return {
    type: FETCH_PRICE_AUDIT_SUCCESS,
    payload: data,
  };
};

export const fetchPriceAuditFailure = (error) => ({
  type: FETCH_PRICE_AUDIT_FAILURE,
  payload: error,
});
